import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import { EstablishmentBlockValidationSchema } from "../schemas/blockUnblockEstablishment.schema";

interface UseBlockEstablishmentProps {
  establishmentId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useBlockEstablishment = ({ establishmentId, onSuccess, onError }: UseBlockEstablishmentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, EstablishmentBlockValidationSchema>({
    mutationKey: ['blockEstablishment', establishmentId],
    mutationFn: (data) => privateAxios.put(`/establishment/companies/${establishmentId}/block`, {
      company: {
        reason: data.block_reason,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useBlockEstablishment;
